import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { postClient, updateClient } from 'projects/access-control/src/app/Infrastructure/Store/clients/clients.action';
import { TranslateService } from '@mangosoft/mango-layout';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

interface translateModalClient {
	title: string;
	titleUpdate: string;
	name: string;
	placeholderName: string;
	nameRequired: string;
	code: string;
	placeholderCode: string;
	codeRequired: string;
	titleDrag: string;
	textDrag: string;
	buttonSave: string;
	buttonCancel: string;
	secretKey: string;
	textAws: string;
	accessKey: string;
	accountId: string;
}
@Component({
	selector: 'app-modal-new-client',
	templateUrl: './modal-new-client.component.html',
	styleUrls: ['./modal-new-client.component.scss'],
})
export class ModalNewClientComponent implements OnInit, OnDestroy {
	fileUrl: string = '';
	select: string = '';
	nameModule: string = '';
	descriptionModule: string = '';
	formClient!: FormGroup;
	secretKey = '';
	accessKey = '';
	disableInputs = false;
	translateModal: translateModalClient = {} as translateModalClient;
	subscriptionTranslate!: Subscription;
	isDragActive = false;
	constructor(
		private store: Store,
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<ModalNewClientComponent>,
		@Inject(MAT_DIALOG_DATA) public data: Client = {} as Client,
		private translate: TranslateService
	) {}
	ngOnInit(): void {
		this.formClient = this.formBuilder.group({
			name: [this.data.name || '', [Validators.required]],
			code: [this.data.code || '', [Validators.required]],
			awsAccount: [this.data.awsAccount || false, [Validators.required]],
			accountId: [''],
		});
		this.statusAccount(this.data?.awsAccount ? this.data?.awsAccount : false);
		this.fileUrl = this.data.logo || '';
		this.dataTranslate();
	}
	onNoClick(): void {
		this.dialogRef.close();
	}
	tabSelect(value: any) {
		this.select = value;
	}
	get f() {
		return this.formClient.controls;
	}
	urlUploadedHandle(event: any) {
		this.fileUrl = event.url;
	}

	urlUploadedErrorHandle(event: any) {
		console.error(event);
	}

	public onDragOver() {
		this.isDragActive = true;
	}

	public onDragLeave(event: Event) {
		this.isDragActive = false;
	}
	handleChange(e: { checked: boolean }) {
		this.statusAccount(e.checked);
	}

	statusAccount(value: boolean) {
		if (value) {
			this.formClient.controls.accountId.enable();
			if (!this.data.sk) {
				this.formClient.controls.accountId.setValidators([Validators.required]);
			}
			this.disableInputs = false;
		} else {
			this.formClient.controls.accountId.disable();
			this.disableInputs = true;
		}
		this.formClient.controls.accountId.updateValueAndValidity();
	}
	dataSecretKey(secretKey: string) {
		this.secretKey = secretKey;
	}

	dataAccessKey(access: string) {
		this.accessKey = access;
	}

	createClient() {
		if (!this.formClient.invalid) {
			const client: Client = this.formClient.value;
			client.logo = this.fileUrl;
			client.accessKey = this.accessKey;
			client.secretKey = this.secretKey;
			if (this.data.sk) {
				this.store.dispatch(updateClient({ params: this.data, client }));
			} else {
				this.store.dispatch(postClient({ client }));
			}
			this.onNoClick();
		}
	}

	dataTranslate() {
		this.subscriptionTranslate = this.translate.init('AccessControl').subscribe((data) => {
			this.translateModal = data.pages.clients.modalClients;
		});
	}
	validatedRequiredForm(): boolean {
		if (!this.data.sk) {
			if (this.formClient.value.awsAccount) {
				return this.secretKey.length > 0 && this.accessKey.length > 0 && !this.formClient.invalid
					? false
					: true;
			}
			return this.formClient.invalid;
		} else {
			return this.formClient.invalid;
		}
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
